import { connect } from 'react-redux';
import { isLoggedIn as selectIsLoggedIn } from 'redux/saga/selectors/user';
import { selectDistanceUnit } from 'redux/modules/locale';
import { keywordAutocomplete, searchLayoutByName, userPermissions } from 'redux/saga/entities/bound';
import { deepExtract } from 'helpers/deep';
import { decorateWith, withName } from 'helpers/decorator';
import { SearchVenue } from 'features/Search/models/SearchVenue';
import { SEARCH } from 'constants/filter-sets';
import { filterSetFilters } from 'redux/saga/selectors';
import { HEADER_LAYOUT } from '../Search.constants';
import { PANEL_NAMES, PANEL_ITEM_LIMIT } from './SearchBox.constants';
import { KeywordField } from './KeywordField';
import { removeSearchboxHistoryItem, searchPanelItemSelected } from './SearchBox.saga';
import {
  clearKeywordField,
  setKeywordFieldValue,
  setOpenPanel,
  closeOpenPanel,
  selectSearchBoxState,
} from './SearchBox.reducer';

const mapDispatchToProps = {
  onFieldFocus: setOpenPanel.bind(null, PANEL_NAMES.keyword),
  onSelect: searchPanelItemSelected.bind(null, PANEL_NAMES.keyword),
  onRemoveItem: removeSearchboxHistoryItem.bind(null, PANEL_NAMES.keyword),
  onClose: closeOpenPanel,
  onClear: clearKeywordField,
  onValueChange: setKeywordFieldValue,
};

export const mapStateToProps = state => {
  const searchBox = selectSearchBoxState(state);
  const inputValue = searchBox.keywordFieldValue;
  const filters = filterSetFilters(state, SEARCH);
  const resultType = deepExtract('result_type.value', filters);

  let venues;
  let activities;
  let history = [];
  let isLoading;

  if (inputValue) {
    const { keywordKey: lastKeyToHaveLoaded } = searchBox;
    const results = keywordAutocomplete.data(state, lastKeyToHaveLoaded) || [];
    // We only want to show a loader if there aren’t previous results to show
    if (results.length === 0) {
      isLoading = lastKeyToHaveLoaded !== inputValue;
    }
    venues = deepExtract('entries', results.find(({ type }) => type === 'venues'), []);
    activities = deepExtract('entries', results.find(({ type }) => type === 'activities'), []);
    activities = activities.slice(0, PANEL_ITEM_LIMIT.activityMatches);
  } else {
    isLoading = searchLayoutByName.loading(state, HEADER_LAYOUT);
    const headerData = isLoading ? {} : searchLayoutByName.data(state, HEADER_LAYOUT);
    venues = deepExtract('popular_studios.data', headerData, []);
    activities = deepExtract('popular_activities.data', headerData, []);
    history = deepExtract('keyword_history.data', headerData, []);
  }

  history = history.slice(0, PANEL_ITEM_LIMIT.history);
  venues = venues.slice(0, PANEL_ITEM_LIMIT.venue);
  const distanceUnit = selectDistanceUnit(state);
  const isLoggedIn = selectIsLoggedIn(state);
  const canSearchByFavorites = !!(userPermissions.data(state) || {}).classpass_staff;

  return {
    canSearchByFavorites,
    isLoading,
    isLoggedIn,
    hasResults: [venues, activities, history].some(arr => arr.length),
    blurredValue: searchBox.keywordDisplayValue,
    hasQuery: inputValue.length > 0,
    venues: venues.map(venue => new SearchVenue(venue, { distanceUnit })),
    history,
    activities,
    inputValue,
    resultType,
  };
};

export const KeywordFieldContainer = decorateWith(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withName('KeywordFieldContainer')
)(KeywordField);
